import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { UserProfileService } from '../../../services/user/user-profile.service';
import { cn } from '../../../../utils/utils';

/**
 * A round photo, or initials in ink on the sunken grey when there is none
 * (or it fails to load). Decorative: whatever it sits in carries the name.
 */
@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.css',
})
export class AvatarComponent implements OnChanges {
  userService = inject(UserProfileService);
  merge = cn;
  @Input() imageSrc: string | null = '';
  @Input() class: string = '';
  @Input() InitialClass: string = '';
  /** Full name for the initials. Falls back to the name on the sign-in token. */
  @Input() name: string | null = '';
  /** Diameter in pixels. */
  @Input() size = 36;

  /** True once the current image failed to load; initials show instead. */
  imageFailed = false;

  get userDetails() {
    return this.userService.userDetails;
  }

  get showImage(): boolean {
    return !!this.imageSrc && !this.imageFailed;
  }

  /** "Thabo Mokoena" → "TM", "Thabo" → "T". Never "undefined". */
  get Inititals() {
    const source = (this.name || this.userDetails?.name || this.userDetails?.email || '').toString().trim();
    const words = source.split(/\s+/).filter(Boolean);
    if (!words.length) return '';
    const first = words[0].charAt(0);
    const last = words.length > 1 ? words[words.length - 1].charAt(0) : '';
    return `${first}${last}`.toUpperCase();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['imageSrc']) this.imageFailed = false;
  }

  onImageError() {
    this.imageFailed = true;
  }
}
